import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import styles from "./index.module.scss";
import AvatarC from "../avatar";

export default function BottomBar({ type }: { type: string }) {
  let location = useLocation();
  const routePattern = /^\/internal\/[a-f0-9-]{36}$/i;
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj && JSON.parse(userObj ?? "");
  const mapPersist = localStorage.getItem("map-persist");
  const filter = localStorage.getItem("filter");
  const mapPersistParse = mapPersist && JSON.parse(mapPersist);
  const filterParse =
    filter !== null
      ? JSON.parse(filter)
      : {
          state: { name: "CA" },
          status: { name: "Active" }
        };
  const params = new URLSearchParams();
  if (mapPersist) {
    Object.keys(mapPersistParse).forEach((key) => {
      if (mapPersistParse[key]) {
        params.set(key, mapPersistParse[key]);
      }
    });
  }

  if (filterParse && typeof filterParse === "object") {
    Object.keys(filterParse).forEach((key) => {
      if (
        filterParse[key] &&
        filterParse[key].name !== undefined &&
        filterParse[key].name !== null
      ) {
        params.set(key, filterParse[key].name);
      }
    });
  }

  const propertiesUrl = `/properties?${params.toString()}`;
  const externalPattern = /^\/external\/[a-zA-Z0-9]+$/i;

  if (externalPattern.test(location.pathname)) {
    return null;
  }

  return (
    <div
      className={
        routePattern.test(location.pathname) ||
        window.location.pathname === "/flipper-vault"
          ? `${styles.bottomWrapDetails}`
          : `${styles.bottomWrap}`
      }
    >
      <div className={styles.menuItem}>
        <NavLink
          to={type === "agent" ? propertiesUrl : "/investor/properties-listing"}
        >
          <img
            src={
              location.pathname.startsWith("/properties") ||
              location.pathname.startsWith("/investor/properties-listing")
                ? "/images/bottombar-property.svg"
                : "/images/building-skyscraper-active.svg"
            }
            alt=""
          />
          Properties
        </NavLink>
      </div>
      <div className={styles.menuItem}>
        <NavLink to={type === "agent" ? "/dashboard" : "/investor/dashboard"}>
          <img
            src={
              location.pathname === "/dashboard" ||
              location.pathname === "/investor/dashboard"
                ? "/images/layout-dashboard-active.svg"
                : "/images/bottombar-dashboard.svg"
            }
            alt=""
          />
          Dashboard
        </NavLink>
      </div>
      {type === "agent" && (
        <div className={styles.menuItem}>
          <NavLink to={"/calling-pipeline"}>
            <img
              src={
                location.pathname === "/calling-pipeline"
                  ? "/images/calling-icon.svg"
                  : "/images/calling-icon-mobile.svg"
              }
              alt=""
            />
            Calling Pipeline
          </NavLink>
        </div>
      )}
      {type == "agent" ? (
        <div className={styles.menuItem}>
          <NavLink to="/profile">
            <AvatarC
              className={styles.avatar}
              size="normal"
              shape="circle"
              label={
                userDetail
                  ? `${userDetail?.name?.slice(0, 1)}${userDetail?.name
                      ?.split(" ")[1]
                      ?.slice(0, 1)}`
                  : "UA"
              }
            />
            Profile
          </NavLink>
        </div>
      ) : (
        <div className={styles.menuItem}>
          <NavLink
            to="/investor-login"
            onClick={() => {
              localStorage.removeItem("investor-access-token");
              localStorage.removeItem("sfid");
              localStorage.removeItem("userId");
              localStorage.removeItem("mobileNumber");
            }}
          >
            {/* <AvatarC
            className={styles.avatar}
            size="normal"
            shape="circle"
            label={
              userDetail
                ? `${userDetail?.name?.slice(0, 1)}${userDetail?.name
                    ?.split(" ")[1]
                    ?.slice(0, 1)}`
                : "UA"
            }
          /> */}
            <img
              src="/images/logout.svg"
              alt="logout"
              style={{ marginLeft: "6px" }}
            />
            Logout
          </NavLink>
        </div>
      )}
    </div>
  );
}
